import React from 'react';
import { Iframe } from './styled';

export const Help = () => (
  <Iframe src="https://www.meindach.de/partner/vertriebsradar/hilfe/" />
);
